import {
  ATUALIZAR_PARECER,
  ADICIONAR_SITUACOES
} from "./actions";


const initialState = {
  parecer: {},
  situacoes: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADICIONAR_SITUACOES:
      return { ...state, situacoes: [...action.situacoes] };
    case ATUALIZAR_PARECER:
      return { ...state, parecer: { ...state.parecer, ...action.parecer } };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/paginas/parecer/reducers.js